import { TOGGLE_ADD_FEEDS_D, TOGGLE_APPSMORE_D, TOGGLE_CUSTOMIZATION_D, TOGGLE_MANAGE_FEEDS_D, TOGGLE_PLAN_D, TOGGLE_THEMES_SECTION_D, TOGGLE_PUBLISH_D, TOGGLE_AUTOPILOT_D, TOGGLE_PHOTOBOOTH_UPGRADE } from "../reducers/keys";

export const togglePlanSection_D = (toggleValue) => {     
    return { type: TOGGLE_PLAN_D, payload: toggleValue }
}

export const toggleAppsMoreSection_D = (toggleValue) => {
    return { type: TOGGLE_APPSMORE_D, payload: toggleValue }
}

export const toggleAddFeedsSection_D = (toggleValue, route, navigate) => {
    if (route) navigate(route);
    return { type: TOGGLE_ADD_FEEDS_D, payload: toggleValue }
}
export const toggleManageSection_D = (toggleValue) => {
    return { type: TOGGLE_MANAGE_FEEDS_D, payload: toggleValue }
}
export const toggleThemesSection_D = (toggleValue) => {

    return { type: TOGGLE_THEMES_SECTION_D, payload: toggleValue }
}
export const toggleCustomizationSection_D = (toggleValue) => {
    return { type: TOGGLE_CUSTOMIZATION_D, payload: toggleValue }
}
export const togglePublishSection_D = (toggleValue) => { 
    return { type: TOGGLE_PUBLISH_D, payload: toggleValue }
}
export const toggleAutoPilot_D = (toggleValue) => {
    return { type: TOGGLE_AUTOPILOT_D, payload: toggleValue }
}
export const togglePhotoBoothUpgrade = (toggleValue) => {
    return { type: TOGGLE_PHOTOBOOTH_UPGRADE, payload: toggleValue }
}